/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BillingReason,
    BillingReasonFromJSON,
    BillingReasonFromJSONTyped,
    BillingReasonToJSON,
    RepoActivationState,
    RepoActivationStateFromJSON,
    RepoActivationStateFromJSONTyped,
    RepoActivationStateToJSON,
} from './';

/**
 * 
 * @export
 * @interface RepoActivation
 */
export interface RepoActivation {
    /**
     * 
     * @type {RepoActivationState}
     * @memberof RepoActivation
     */
    state: RepoActivationState;
    /**
     * 
     * @type {BillingReason}
     * @memberof RepoActivation
     */
    billingReason?: BillingReason;
}

export function RepoActivationFromJSON(json: any): RepoActivation {
    return RepoActivationFromJSONTyped(json, false);
}

export function RepoActivationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepoActivation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'state': RepoActivationStateFromJSON(json['state']),
        'billingReason': !exists(json, 'billingReason') ? undefined : BillingReasonFromJSON(json['billingReason']),
    };
}

export function RepoActivationToJSON(value?: RepoActivation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'state': RepoActivationStateToJSON(value.state),
        'billingReason': BillingReasonToJSON(value.billingReason),
    };
}

